module.exports = __webpack_public_path__ + "static/nobox-yellow-0a6d3483f7ab2c805f15bad6b44b2181.png";